import { TwoFactorSmsConfirm } from "@/components/Portal/UserAccount/Security/TwoFactorSmsConfirm";
import { useResendActionForSmsSetup } from "@/hooks/useResendSms";

export const TwoFactorConfirmSmsView = () => (
  <div className="max-w-[560px]">
    <TwoFactorSmsConfirm useResendAction={useResendActionForSmsSetup} />
  </div>
);
